
// client/src/utils/creditApi.js
import api from './api';

export const CREDIT_FEATURES = Object.freeze({
  ESTIMATION_ITEM: 'estimation_item',
  DESIGN_VISUAL: 'design_visual',
});

export async function fetchCreditBalance() {
  const response = await api.get('/credits/balance');
  return response.data || { available: 0 };
}

export async function quoteCredits(features) {
  const payload = Array.isArray(features) ? features : [];
  const response = await api.post('/credits/quote', { features: payload });
  return response.data || { totalCost: 0, shortfall: 0, available: 0 };
}

export async function commitCredits({ features, requestId, metadata } = {}) {
  const response = await api.post('/credits/commit', {
    features: Array.isArray(features) ? features : [],
    requestId,
    metadata,
  });
  return response.data || { totalCost: 0, shortfall: 0, available: 0 };
}
